export default {
    getHeaderFields: state => state.headerFields,
    getActions: state => state.actions,
    getAdditionalTableConfig: state => state.dataTableOptions,
    getSearchFields: state => state.searchFields
}
